/**
 * TranscribeButton - Ação "Transcrever" exibida na linha de meta (junto ao
 * horário) de mensagens de áudio sem transcrição (plainText vazio).
 * Dispara o STT sob demanda no backend, que salva o texto no plainText da
 * mensagem (nunca transcreve duas vezes).
 *
 * Herda fonte e cor da linha de meta do balão (renderMeta em ChatMessage).
 */

import React from 'react';
import { toast } from 'sonner';
import { Icon } from '@/shared/icons';
import { useTranscribeMessage } from '../hooks/useTranscribeMessage';

interface TranscribeButtonProps {
  messageId: string;
}

export const TranscribeButton: React.FC<TranscribeButtonProps> = ({ messageId }) => {
  const { mutate, isPending } = useTranscribeMessage();

  const handleClick = () => {
    if (isPending) return;
    mutate(messageId, {
      onError: (error: any) => {
        toast.error(error?.response?.data?.message || 'Erro ao transcrever áudio');
      },
    });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={isPending}
      className="inline-flex items-center gap-1 cursor-pointer hover:underline disabled:cursor-wait disabled:opacity-70"
      style={{ background: 'none', border: 0, padding: 0, color: 'inherit', font: 'inherit' }}
      title="Transcrever áudio"
      data-testid="chat-message-transcribe"
    >
      <Icon
        name={isPending ? 'loader' : 'type'}
        className={`w-3 h-3 ${isPending ? 'animate-spin' : ''}`}
      />
      {isPending ? 'Transcrevendo…' : 'Transcrever'}
    </button>
  );
};

export default TranscribeButton;
